module.exports = __webpack_public_path__ + "img/blox_brixbrixtoke.691ff47.png";